<template>
  <div class="box-table-sale">
    <vxe-grid
      ref="refTableSale"
      class="table-sale"
      :min-height="tableConfig.minHeight"
      :show-footer="!parent"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="headerCellClassName"
      :toolbar-config="tableConfig.toolbarConfig"
      :row-config="{ isCurrent: false }"
      :columns="tableColumn"
      :data="selfData"
      :footer-method="footerMethod"
    >
      <!-- 表格按钮位置 -->
      <template #buttons>
        <div v-if="tableTitleArr.length > 1" class="table-title">
          <span v-for="(item, index) in tableTitleArr" :key="index">
            <span v-if="index === 1">(</span>
            <span :class="item.isActive ? 'c-green' : ''">{{ item.name }}</span>
            <span v-show="index !== 0 && !item.isActive && item.name" class="m-x-2">&gt;</span>
            <span v-if="index === tableTitleArr.length - 1">)</span>
          </span>
        </div>
        <div v-else class="table-title">
          <span class="c-green">销售清单</span>
        </div>
      </template>

      <!-- 排序 -->
      <template #default_move>
        <span v-if="!disabled" class="iconfont icon-drag cursor-move"></span>
      </template>

      <!-- 序号 -->
      <template #default_seq="{ row, rowIndex }">
        <div class="flex flex-center">
          <span v-if="row.is_xie_tong" class="iconfont icon-xiezuo c-blue f-s-24 m-l-5"></span>
          <span v-else>{{ rowIndex + 1 }}</span>
        </div>
      </template>

      <!-- 商品图片 -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image
          v-if="row.list_chan_pin_tu"
          :list.sync="row.list_chan_pin_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>

      <!-- 商品名称 -->
      <template #default_name="{ row, rowIndex }">
        <div class="flex flex-x-between flex-y-center">
          <el-input v-model="row.name" size="mini" class="flex-1" :disabled="disabled">
            <el-link
              slot="append"
              type="primary"
              :underline="false"
              @click="openPopupVerifyGoodsEdit(rowIndex)"
            >
              {{ disabled ? '查看商品' : '编辑商品' }}
            </el-link>
          </el-input>
        </div>
      </template>

      <!-- 规格 -->
      <template #default_spec="{ row }">
        <el-input v-model="row.spec" size="mini" :disabled="disabled" />
      </template>

      <!-- 数量 -->
      <template #default_counts="{ row }">
        <el-input
          v-model="row.counts"
          class="input-center"
          type="number"
          size="mini"
          :disabled="disabled"
          @input="changeCounts(row)"
        />
      </template>

      <!-- 每套数量 -->
      <template #default_counts_unit="{ row }">
        <el-input
          v-model="row.counts_unit"
          type="number"
          size="mini"
          :disabled="disabled"
          @input="changeCounts(row)"
        >
          <span v-if="row.counts_unit && row.counts" slot="suffix">共{{ row.counts }}</span>
        </el-input>
      </template>

      <!-- 单位 -->
      <template #default_unit="{ row }">
        <el-input
          v-model="row.unit"
          class="input-center"
          type="text"
          size="mini"
          :disabled="disabled"
        />
      </template>

      <!-- 单价 -->
      <template #default_goods_price="{ row }">
        <el-input
          v-if="isCustomGoodsPrice(row)"
          v-model="row.table_data_1[0].goods_price"
          class="input-center"
          type="number"
          size="mini"
          :disabled="disabled"
        />
        <el-input
          v-else
          v-model="row.goods_price"
          class="input-center"
          type="number"
          size="mini"
          disabled
        />
      </template>

      <!-- 未税销售单价 -->
      <template #default_wei_shui_sales_price="{ row }">
        <el-input
          v-model="row.wei_shui_sales_price"
          class="input-center"
          type="number"
          size="mini"
          :disabled="disabled"
        />
      </template>

      <!-- 未税销售金额 -->
      <template #default_wei_shui_sales_amount="{ row }">
        {{ !parent || Number(row.wei_shui_sales_price) ? row.wei_shui_sales_amount : '' }}
      </template>

      <!-- 含税销售单价 -->
      <template #default_sales_price="{ row }">
        <el-input
          v-model="row.sales_price"
          class="input-center"
          type="number"
          size="mini"
          :disabled="disabled"
        />
      </template>

      <!-- 含税销售金额 -->
      <template #default_sales_amount="{ row }">
        {{ !parent || Number(row.sales_price) ? row.sales_amount : '' }}
      </template>

      <!-- 每件利润 -->
      <template #default_profit_row_unit="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_row_unit : '' }}
      </template>

      <!-- 合计利润 -->
      <template #default_profit_row="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_row : '' }}
      </template>

      <!-- 利润率 -->
      <template #default_profit_rate="{ row }">
        {{ !parent || Number(row.sales_price) ? row.profit_rate : '' }}
      </template>

      <!-- 税率 -->
      <template #default_shuilv="{ row }">
        <span>{{ row.shuilv }}</span>
      </template>

      <!-- 税额 -->
      <template #default_shuie="{ row }">
        <span>{{ row.shuie }}</span>
      </template>

      <!-- 备注 -->
      <template #default_remark="{ row }">
        <el-input v-model="row.remark" size="mini" :disabled="disabled" />
      </template>

      <template #default_do="{ rowIndex }">
        <el-link v-if="!disabled" type="success" size="mini" @click="rowAddPrev(rowIndex)">
          增行↑
        </el-link>
        <el-link v-if="!disabled" type="success" size="mini" @click="rowAddNext(rowIndex)">
          增行↓
        </el-link>
        <el-link v-if="!disabled" type="danger" size="mini" @click="rowDelete(rowIndex)">
          删行
        </el-link>
      </template>

      <template #default_bom_do="{ row, rowIndex }">
        <el-link
          v-if="!disabled && row.tableBomData.length"
          type="danger"
          @click="bomDelete(row, rowIndex)"
        >
          删除bom表
        </el-link>
        <el-link
          v-if="!disabled && !row.tableBomData.length"
          type="success"
          @click="bomAdd(row, rowIndex)"
        >
          创建bom表
        </el-link>
        <el-link v-if="!disabled && row.tableBomData.length" type="primary" @click="bomToggle(row)">
          {{ row.isShow === false ? '展开↓' : '收起↑' }}
        </el-link>
      </template>
    </vxe-grid>

    <!-- bom表 递归 -->
    <template v-for="(item, index) in selfData">
      <TableSale
        v-if="item.tableBomData.length && item.isShow !== false"
        :key="index"
        :tableTitle="`${tableTitle}>${item.name}`"
        :parent="item"
        :data.sync="item.tableBomData"
        :disabled="disabled"
        :statusName="statusName"
      />
    </template>

    <!-- 弹窗-编辑 -->
    <b-popup-verify-goods-edit
      v-if="isShowPopupVerifyGoodsEdit"
      :show.sync="isShowPopupVerifyGoodsEdit"
      :data.sync="selfData[activeIndex]"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import math from './math'
export default {
  name: 'TableSale',
  props: {
    tableTitle: {
      type: String,
      required: true
    },
    parent: {
      type: Object,
      default: () => {
        return null
      }
    },
    data: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    statusName: {
      type: String,
      default: ''
    },
    shuilv: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      jin_du_list: ['待执行', '执行中', '已完成'],
      rowIndex: null,
      columnIndex: null,

      selfData: [],
      isShowPopupVerifyGoodsEdit: false, // 编辑
      activeIndex: null // 当前行索引
    }
  },
  provide() {
    return {
      inject_tableSale: () => {
        return this.selfData[this.activeIndex]
      }
    }
  },
  computed: {
    isHanShui() {
      return !!Number(this.shuilv)
    },
    // 表格配置合并
    tableConfig() {
      let obj = {
        toolbarConfig: {
          enabled: true,
          slots: {
            buttons: 'buttons'
          }
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    // 表格标题
    tableTitleArr() {
      let arr = this.tableTitle.split('>')
      let result = arr.map((item, index) => {
        return {
          name: item,
          isActive: index === arr.length - 1
        }
      })
      return result
    },
    tableColumn() {
      let result = []
      let arrStart = [
        {
          fixed: 'left',
          title: '排序',
          width: 40,
          slots: { default: 'default_move' }
        },
        {
          fixed: 'left',
          title: '序号',
          width: 40,
          slots: { default: 'default_seq' }
        },
        {
          title: '商品图片',
          width: 63,
          slots: { default: 'default_list_chan_pin_tu' }
        },
        {
          title: '商品名称',
          width: 144,
          slots: { default: 'default_name' }
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 100,
          slots: { default: 'default_spec' }
        },
        {
          title: '单位',
          field: 'unit',
          width: 80,
          slots: { default: 'default_unit' }
        }
      ]
      let arrCenter = []

      let arrTop = [
        {
          title: '数量',
          field: 'counts',
          width: 80,
          slots: { default: 'default_counts' }
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80,
          slots: { default: 'default_goods_price' }
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        // this.isHanShui 为false时，显示未税销售单价和未税销售金额
        {
          title: this.isHanShui ? '含税销售单价' : '未税销售单价',
          field: `${this.isHanShui ? 'sales_price' : 'wei_shui_sales_price'}`,
          slots: {
            default: `${this.isHanShui ? 'default_sales_price' : 'default_wei_shui_sales_price'}`
          },
          width: 82
        },
        {
          title: this.isHanShui ? '含税销售金额' : '未税销售金额',
          field: `${this.isHanShui ? 'sales_amount' : 'wei_shui_sales_amount'}`,
          slots: {
            default: `${this.isHanShui ? 'default_sales_amount' : 'default_wei_shui_sales_amount'}`
          },
          width: 82
        },
        // this.isHanShui 为true时，显示含税销售单价和含税销售金额
        // {
        //   title: '含税销售单价(元)',
        //   field: 'sales_price',
        //   slots: {
        //     default: 'default_sales_price'
        //   },
        //   width: 110
        // },
        // {
        //   title: '含税销售金额(元)',
        //   field: 'sales_amount',
        //   slots: {
        //     default: 'default_sales_amount'
        //   },
        //   width: 130
        // },
        {
          title: '每件利润',
          field: 'profit_row_unit',
          slots: { default: 'default_profit_row_unit' }
        },
        {
          title: '合计利润',
          field: 'profit_row',
          slots: { default: 'default_profit_row' }
        },
        {
          title: '利润率(%)',
          field: 'profit_rate',
          width: 70,
          slots: { default: 'default_profit_rate' }
        },
        {
          title: '税率',
          slots: { default: 'default_shuilv' },
          width: 60
        },
        {
          title: '税额',
          slots: { default: 'default_shuie' },
          width: 60
        },
        {
          title: '备注',
          slots: { default: 'default_remark' },
          width: 100
        }
      ]
      let arrBom = [
        {
          title: '每套数量',
          width: 80,
          slots: { default: 'default_counts_unit' }
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80,
          slots: { default: 'default_goods_price' }
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: ''
        }
      ]
      let arrEnd = [
        {
          title: '操作',
          width: 120,
          slots: { default: 'default_do' }
        },
        {
          title: 'bom表操作',
          width: 122,
          slots: { default: 'default_bom_do' }
        }
      ]
      arrCenter = !this.parent ? arrTop : arrBom
      result = [...arrStart, ...arrCenter, ...arrEnd]
      return result
    }
  },
  watch: {
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
          if (this.rowIndex !== null && this.columnIndex !== null) {
            this.$refs.refTableSale.setEditCell(
              this.selfData[this.rowIndex],
              this.tableColumn[this.columnIndex].field
            )
          }
        }
      },
      deep: true,
      immediate: true
    },
    selfData: {
      handler(val) {
        if (JSON.stringify(this.data) !== JSON.stringify(val)) {
          this.$emit('update:data', this.$util.deepCopy(val))
        }
      },
      deep: true
    }
  },
  mounted() {
    if (!this.disabled) this.rowDrop()
  },
  methods: {
    // 是否自定义单价
    isCustomGoodsPrice(row) {
      let result = true
      result =
        row.tableBomData.length ||
        row.table_data_2.length ||
        row.table_data_3.length ||
        row.table_data_4.length
      return !result
    },
    // 行拖拽
    rowDrop() {
      this.$nextTick(() => {
        let $table = this.$refs.refTableSale
        let $sortContent = $table.$el.querySelector('.body--wrapper>.vxe-table--body tbody')
        this.sortable = Sortable.create($sortContent, {
          handle: '.icon-drag',
          animation: 150,
          onEnd: ({ newIndex, oldIndex }) => {
            let data = this.$util.deepCopy(this.selfData)
            let oldItem = this.$util.deepCopy(data[oldIndex])
            // 上移
            if (newIndex < oldIndex) {
              if (newIndex === 0) {
                data.splice(oldIndex, 1)
                data.unshift(oldItem) // 顶部
              } else {
                data.splice(oldIndex, 1)
                data.splice(newIndex, 0, oldItem)
              }
            }
            // 下移
            if (newIndex > oldIndex) {
              if (newIndex === data.length - 1) {
                data.push(oldItem) // 底部
                data.splice(oldIndex, 1)
              } else {
                data.splice(newIndex + 1, 0, oldItem)
                data.splice(oldIndex, 1)
              }
            }
            this.selfData = this.$util.deepCopy(data)
          }
        })
      })
    },
    // 表格单元格样式设置
    headerCellClassName({ column, row }) {
      if (row && row.is_xie_tong) return 'bg-blue'
      if (column.title.includes('未税')) return 'c-blue'
      if (column.title.includes('含税')) return 'c-red'
      if (column.title === 'bom表操作') return 'bg-green'
      if (column.title === 'bom表操作') return 'bg-green'
      if (column.slots && column.slots.edit) return 'edit'

      return null
    },
    // 获取-当前选中记录
    getCurrentRecord() {
      return this.$refs.refTableSale.getCurrentRecord()
    },
    // 获取-当前选中记录索引
    getRowIndex(row) {
      return this.$refs.refTableSale.getRowIndex(row)
    },
    // 行-增行-上
    rowAddPrev(index) {
      let result = this.$util.deepCopy(this.$constant.newTableSaleObj)
      if (this.parent) {
        result.name = `${this.parent.name}-零件${this.parent.tableBomData.length + 1}`
      } else {
        result.name = `商品${this.selfData.length + 1}`
      }
      this.selfData.splice(index, 0, result)
      this.$refs.refTableSale.clearCurrentRow()
    },
    // 行-增行-下
    rowAddNext(index) {
      let result = this.$util.deepCopy(this.$constant.newTableSaleObj)
      if (this.parent) {
        result.name = `${this.parent.name}-零件${this.parent.tableBomData.length + 1}`
      } else {
        result.name = `商品${this.selfData.length + 1}`
      }
      this.selfData.splice(index + 1, 0, result)
      this.$refs.refTableSale.clearCurrentRow()
    },
    // 行-删行
    rowDelete(index) {
      if (!this.parent) {
        if (this.selfData.length <= 1) {
          this.$message.error('销售清单至少保留一行')
          return
        }
      } else {
        if (this.selfData.length <= 2) {
          this.$message.error('bom表清单至少保留两行')
          return
        }
      }
      this.selfData.splice(index, 1)
    },
    // bom-新增
    bomAdd(row) {
      let result = this.$util.deepCopy(this.$constant.newTableSaleObj)
      result.counts = row.counts ? row.counts : 1
      let result1 = this.$util.deepCopy(result)
      let result2 = this.$util.deepCopy(result)
      result1.name = `${row.name}-零件1`
      result2.name = `${row.name}-零件2`
      row.tableBomData.push(result1)
      row.tableBomData.push(result2)
      row.table_data_2 = [] // 零件数据清除
      this.$set(row, 'isShow', true) // 默认展开
    },
    // bom-展开收起切换
    bomToggle(row) {
      let isShow = row.isShow !== false // 当前是否展开
      this.$set(row, 'isShow', !isShow)
    },
    // bom-删除
    bomDelete(row) {
      row.tableBomData = []
    },
    // 编辑
    openPopupVerifyGoodsEdit(index) {
      this.activeIndex = index
      this.isShowPopupVerifyGoodsEdit = true
    },
    // 更新-数量
    changeCounts(row) {
      math.rowCounts(row, this.parent) // 计算-数量
      // 是否有bom表
      if (row.tableBomData.length) {
        row.tableBomData.forEach((item) => {
          math.rowCounts(item, row) // 计算-数量
          if (item.tableBomData.length) this.changeCounts(item)
        })
      }
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'

          if (
            [
              'counts',
              'goods_price',
              'goods_amount',
              'sales_price',
              'sales_amount',
              'wei_shui_sales_price',
              'wei_shui_sales_amount',
              'profit_row_unit',
              'profit_row'
            ].includes(column.field)
          ) {
            return this.$util.listFieldTotal(data, column.field)
          }
          if (['profit_rate'].includes(column.field)) {
            return this.$util.listFieldAverage(data, column.field)
          }
        })
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.box-table-sale {
  width: 1548px;
  .table-title {
    padding: 3px 0;
    font-size: 14px;
    color: #000;
    font-weight: bold;
  }
  .table-sale {
    margin: -1px;
  }
  /deep/ .vxe-grid--toolbar-wrapper {
    padding: 0 5px;
    border: 1px solid #e8eaec;
    border-bottom: none;
  }
  /deep/ .vxe-cell--valid-error-hint {
    display: none;
  }
  /deep/ .vxe-table--render-default .vxe-header--column.bg-green {
    background-color: #67c33a;
    color: #fff;
  }
  /deep/ .vxe-table--render-default.vxe-editable .vxe-body--column.bg-green {
    background-color: #f0f9eb;
  }
  /deep/ .vxe-table--render-default.vxe-editable .vxe-body--column.bg-blue {
    background-color: #c6e2ff;
  }
  /deep/ .vxe-toolbar {
    padding: 5px 0;
  }
}
</style>
